<template>
  <el-dialog
    :title="dialogTitle"
    :visible="dialogVisible"
    v-if="dialogVisible"
    @close="dialogClose"
    width="500px"
    height="454px"
    :close-on-click-modal="false"
  >
    <div class="image-qrcode"><img :src="imgSrc" /></div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      imgSrc: ''
    };
  },
  props: ['dialogVisible', 'imageUrl', 'dialogTitle'],
  methods: {
    dialogClose: function () {
      this.$emit('dialogClose', false);
      this.resetForm('form');
    }
  },
  created() {},
  mounted() {
    this.imgSrc = this.imageUrl;
  },
  destroyed() {}
};
</script>

<style scoped>
.image-qrcode {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/humanResources/schoolManagement/schoolQRCodeDialog.vue